import React from 'react';

const LOGO_MASK_STYLE = {
  WebkitMaskImage: 'url(/flipforward-logo.png)',
  maskImage: 'url(/flipforward-logo.png)',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
};

export default function Footer() {
  return (
    <footer className="border-t border-dd-line/60 bg-dd-bg py-6 px-4">
      <a
        href="https://flipforward.be"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Built by FlipForward"
        className="group flex items-center justify-center gap-2 text-xs tracking-wide"
      >
        <span className="text-dd-dim">Built by</span>
        <span
          aria-hidden="true"
          style={{ ...LOGO_MASK_STYLE, backgroundColor: 'var(--dd-lime)' }}
          className="inline-block h-4 w-4 transition-colors group-hover:bg-dd-lime-dim"
        />
        <span className="font-semibold text-dd-lime group-hover:text-[var(--dd-lime-dim)] transition-colors">
          FlipForward
        </span>
      </a>
    </footer>
  );
}
